import React from "react";

export const withLoanForm = (WrappedComponent, options = {}) => {
  return (props) => {
    return (
      <form
        id={props.formId}
        noValidate
        autoComplete="off"
        className="register-form"
        onSubmit={(event) => {
          event.preventDefault();
          props.handleSubmit();
        }}
      >
        <WrappedComponent {...props} />
        <input type="submit" style={{ display: "none" }} />
      </form>
    );
  };
};

